import { ObjectivesFormFilePresenter } from '@mailings/components/creators/personalized-mailing-creator-wizard/components/mailing-objectives/forms/file-upload/ObjectivesFormFilePresenter';
import { ResearchFormFileUploadStatus } from '@mailings/components/creators/personalized-mailing-creator-wizard/components/mailing-objectives/forms/file-upload/ResearchFormFileUploadStatus';
import { ResearchFormType } from '@mailings/components/creators/personalized-mailing-creator-wizard/types/mailingObjectivesForm.types';
import {
  INPUT_ACCEPTANCE_CRITERIA,
  OBJECTIVES_FORM_MAX_FILE_SIZE,
} from '@mailings/components/creators/personalized-mailing-creator-wizard/validations/uploadFile.validations';
import { TagContainer } from '@semcore/ui/tag';
import {
  UploadStatus,
  FileRestrictionsErrors,
  FileRestrictions,
} from '@src/types/files-upload-types';
import { useFormContext, useWatch } from 'react-hook-form';

interface ResearchFormFileUploadProps {
  file: File | null;

  uploadStatus: UploadStatus;
  setUploadStatus: (status: UploadStatus) => void;
  setFileUploadRestrictionsErrors: (
    errors: FileRestrictionsErrors<FileRestrictions> | null,
  ) => void;
  onFileRemove: () => void;
  onFileSelect: (selectedFiles: FileList | null) => void;
  onSelectFromBrandHub: () => void;
  onResourceRemove: () => void;
}

export const ResearchFormFileUpload = ({
  file,
  uploadStatus,
  setUploadStatus,
  setFileUploadRestrictionsErrors,
  onFileRemove,
  onFileSelect,
  onSelectFromBrandHub,
  onResourceRemove,
}: ResearchFormFileUploadProps) => {
  const fileUploaderProps = {
    accept: INPUT_ACCEPTANCE_CRITERIA,
    asFormElement: false,
    fileRestrictions: {
      maxFileSize: OBJECTIVES_FORM_MAX_FILE_SIZE,
      allowedMimeTypes: INPUT_ACCEPTANCE_CRITERIA,
    },
    setFileUploadRestrictionsErrors,
    setFileUploadStatus: setUploadStatus,
    setFiles: onFileSelect,
  };

  const { control } = useFormContext<ResearchFormType>();

  const resourceId = useWatch({
    control,
    name: 'brandHubResourceId',
    defaultValue: undefined,
  });

  const resourceName = useWatch({
    control,
    name: 'brandHubResourceName',
    defaultValue: '',
  });

  const storyDocumentFile = useWatch({ control, name: 'storyDocumentFile' });

  return (
    <>
      {!file && !storyDocumentFile && !resourceId && (
        <ResearchFormFileUploadStatus
          fileUploaderProps={fileUploaderProps}
          uploadStatus={uploadStatus}
          onSelectFromBrandHub={onSelectFromBrandHub}
        />
      )}
      {!!file && (
        <ObjectivesFormFilePresenter
          file={file}
          onRemove={onFileRemove}
        />
      )}
      {!!storyDocumentFile && !file && (
        <ObjectivesFormFilePresenter
          file={storyDocumentFile}
          onRemove={onResourceRemove}
        />
      )}
      {resourceId && !storyDocumentFile && (
        <TagContainer
          className="max-w-full self-start"
          size="l">
          <TagContainer.Tag>
            <TagContainer.Tag.Text ellipsis>{resourceName}</TagContainer.Tag.Text>
          </TagContainer.Tag>
          <TagContainer.Close
            data-test="remove-selected-brandhub-resource-button"
            onClick={onResourceRemove}
          />
        </TagContainer>
      )}
    </>
  );
};
